<template>
  <DSPopover>
    <DSPopoverTrigger as-child>
      <DSButton
        v-bind="$attrs"
        variant="secondary"
        size="icon-sm"
        aria-label="Table settings"
      >
        <Settings />
      </DSButton>
    </DSPopoverTrigger>
    <DSPopoverContent
      align="end"
      class="flex w-60 flex-col gap-2.5"
    >
      <span class="text-xs font-bold uppercase tracking-ds-caps text-muted-foreground">Layout</span>
      <DSRadioGroup v-model="layoutValue">
        <div
          v-for="option in LAYOUT_OPTIONS"
          :key="option.value"
          class="flex flex-col gap-0.5"
        >
          <label
            :for="`pivot-layout-${option.value}`"
            class="flex cursor-pointer items-center gap-2"
          >
            <DSRadioGroupItem
              :id="`pivot-layout-${option.value}`"
              :value="option.value"
            />
            <span class="text-sm font-medium text-foreground">{{ option.label }}</span>
          </label>
          <span class="pl-7 text-xs text-muted-foreground text-pretty">{{ option.hint }}</span>
        </div>
      </DSRadioGroup>
    </DSPopoverContent>
  </DSPopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Settings } from '@lucide/vue'

import { PivotTableLayout } from '@types'

import {
  DSButton,
  DSPopover,
  DSPopoverContent,
  DSPopoverTrigger,
  DSRadioGroup,
  DSRadioGroupItem,
} from '@ds'

const LAYOUT_OPTIONS = [
  { value: 'modern', layout: PivotTableLayout.MODERN, label: 'Modern', hint: 'Groupings nest in a single column that expands in place.' },
  { value: 'classic', layout: PivotTableLayout.CLASSIC, label: 'Classic', hint: 'Each grouping gets its own column, with subtotals after every group.' },
] as const

const layout = defineModel<PivotTableLayout>('layout', { required: true })

defineOptions({
  inheritAttrs: false,
})

const layoutValue = computed({
  get: () => LAYOUT_OPTIONS.find(option => option.layout === layout.value)?.value ?? 'modern',
  set: value => {
    layout.value = LAYOUT_OPTIONS.find(option => option.value === value)!.layout
  },
})
</script>
